import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../services/api';

/**
 * /live/:eventId — the members-only join link for a live Hub session (Jenn, 2026-10-29: "super easy to join
 * anything we do... BUT I don't want our links to be shared and non members to access"). Every Join button and
 * calendar entry points here instead of at Zoom or Google Meet. Behind ProtectedRoute, so a signed-out member
 * signs in once and comes straight back; a signed-in member is sent on to the session at once. Someone who
 * isn't a member never sees the session's address.
 */
export default function JoinLiveEvent() {
  const { eventId } = useParams();
  const [problem, setProblem] = useState(null); // { code, error, title }

  useEffect(() => {
    api.get(`/hub-events/${encodeURIComponent(eventId)}/join`)
      .then(res => window.location.replace(res.data.url))
      .catch(err => setProblem(err.response?.data || { error: 'We could not open that session just now.' }));
  }, [eventId]);

  if (!problem) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-reset-cream px-4">
        <p className="text-reset-brown font-medium">Taking you to your session…</p>
      </div>
    );
  }

  const notMember = problem.code === 'not_member';
  return (
    <div className="flex items-center justify-center min-h-screen bg-reset-cream px-4">
      <div className="w-full max-w-md text-center space-y-4">
        <h1 className="font-serif text-3xl text-reset-brown">
          {notMember ? 'This session is for members' : problem.code === 'ended' ? 'This session has finished' : 'We could not open that session'}
        </h1>
        <p className="text-sm text-gray-600">
          {notMember
            ? 'Join 365reset to come to our live sessions, watch the replays and more.'
            : problem.code === 'ended' ? 'The replay will be in My Events once it is ready.' : problem.error}
        </p>
        <Link
          to={notMember ? '/join' : '/dashboard/events'}
          className="inline-block bg-reset-terracotta text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-reset-brown transition"
        >
          {notMember ? 'Join 365reset' : 'Go to My Events'}
        </Link>
      </div>
    </div>
  );
}
